export const itNis2Content = {
    id: "it-nis2",
    route: "/it-a-nis2",
    menuTitle: "IT a NIS2",
    title: "IT, kybernetická bezpečnost a NIS2",
    headline: "Připravíme vaši organizaci na NIS2",
    lead: "ENERGOSPACE poskytuje komplexní služby v oblasti kybernetické bezpečnosti, telekomunikací a ochrany kritické infrastruktury.",
    summary: "Pomáháme organizacím s auditem, GAP analýzou, dokumentací, monitoringem a praktickou implementací požadavků NIS2.",
    primaryItems: [
        "NIS2 audit a GAP analýza",
        "implementace požadavků NIS2",
        "bezpečnostní dokumentace",
        "penetrační testování",
        "monitoring infrastruktury",
        "dohledové centrum",
        "ochrana kritické infrastruktury",
        "školení managementu a zaměstnanců"
    ],
    sections: [
        {
            title: "Nabízené služby",
            items: [
                "NIS2 audit a GAP analýza",
                "implementace požadavků NIS2",
                "bezpečnostní dokumentace",
                "penetrační testování",
                "monitoring infrastruktury",
                "dohledové centrum",
                "ochrana kritické infrastruktury",
                "školení managementu a zaměstnanců"
            ]
        },
        {
            title: "Cílové skupiny",
            items: [
                "města a obce",
                "energetické společnosti",
                "výrobní podniky",
                "nemocnice",
                "dopravní infrastruktura"
            ]
        }
    ],
    targetGroups: [
        "města a obce",
        "energetické společnosti",
        "výrobní podniky",
        "nemocnice",
        "dopravní infrastruktura"
    ]
};
